import { Model } from './Model';
import { IModel } from './IModel';
import { ModelView } from '../View/ModelView';
export { Model, ModelView }
export type { IModel }
export default Model
